'use client';

import { useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../../contexts/ApiContext';
import { queryKeys } from '../../../../lib/queryClient';
import {
  SetRushMidSkinRequestSideEnum,
  type RushMidSkinsResponse,
} from '../../../../services/generated/Api';
import type { Side } from '../useRushMidMatch';

export function useSkinPersist(): (skinSide: Side, picked: string) => void {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();

  return (skinSide, picked) => {
    const side = skinSide === 'ct' ? SetRushMidSkinRequestSideEnum.Ct : SetRushMidSkinRequestSideEnum.T;
    apiClient.api.rushMidControllerSetSkin({ side, skin: picked }).catch(() => {});
    queryClient.setQueryData<RushMidSkinsResponse>(queryKeys.rushMidSkins, (old) =>
      old && { ...old, [skinSide]: picked });
  };
}
